import { useState } from 'react'
import SetupMFAStep from '../../components/SetupMFAStep'
import { QRCodeSVG as QRCode } from 'qrcode.react'
import { AuthenticatorAppDownload } from './AuthenticatorAppDownload'
import {
  FINISH,
  NEXT,
  SETUP_MFA_TOTP_FOOTNOTE,
  SETUP_MFA_TOTP_MESSAGE_REGISTER_STEP,
  SETUP_MFA_TOTP_MESSAGE_START_REGISTRATION_STEP,
  SETUP_MFA_TOTP_TITLE,
  SETUP_MFA_TOTP_VERIFICATION_CODE,
  SETUP_MFA_TOTP_VERIFICATION_CODE_PLACEHOLDER,
} from '../../constants/ui.labels'
import Box from '@talkdesk/cobalt-react-box'
import Label from '@talkdesk/cobalt-react-label'
import Input from '@talkdesk/cobalt-react-input'
import { Group, GroupItem } from '@talkdesk/cobalt-react-input-group'
import Flex from '@talkdesk/cobalt-react-flex'
import Card from '@talkdesk/cobalt-react-card'

/** @param {{ learnMoreAboutAuthenticatorAppUrl?: any, children?: any, [key: string]: any }} props */
const SetupTOTPStep = ({ learnMoreAboutAuthenticatorAppUrl, ...props }) => (
  <SetupMFAStep
    title={SETUP_MFA_TOTP_TITLE}
    footnoteLabel={SETUP_MFA_TOTP_FOOTNOTE}
    footnoteUrl={learnMoreAboutAuthenticatorAppUrl}
    {...props}
  >
    {props.children}
  </SetupMFAStep>
)

/** @param {{ onPrepareRegistration?: any, googlePlayBadgeUrl?: any, appleStoreBadgeUrl?: any, [key: string]: any }} props */
export const StartRegistrationStep = ({
  onPrepareRegistration,
  googlePlayBadgeUrl,
  appleStoreBadgeUrl,
  ...otherProps
}) => (
  <SetupTOTPStep
    subtitle={SETUP_MFA_TOTP_MESSAGE_START_REGISTRATION_STEP}
    boxContent={
      <AuthenticatorAppDownload
        googlePlayBadgeUrl={googlePlayBadgeUrl}
        appleStoreBadgeUrl={appleStoreBadgeUrl}
      />
    }
    buttonLabel={NEXT}
    buttonAction={onPrepareRegistration}
    {...otherProps}
  />
)

/** @param {{ onFinishRegistration?: any, registrationData?: any, isProcessing?: any, [key: string]: any }} props */
export const RegisterStep = ({
  onFinishRegistration,
  registrationData,
  isProcessing,
  ...otherProps
}) => {
  const [otp, setOtp] = useState('')

  const [prevIsProcessing, setPrevIsProcessing] = useState(isProcessing)
  if (isProcessing !== prevIsProcessing) {
    setPrevIsProcessing(isProcessing)
    if (!isProcessing) setOtp('')
  }

  const finishRegistration = () => {
    onFinishRegistration({
      registrationToken: registrationData.token,
      otp,
    })
  }

  const handleOTPChange = (event) => setOtp(event.target.value)

  return (
    <SetupTOTPStep
      subtitle={SETUP_MFA_TOTP_MESSAGE_REGISTER_STEP}
      boxContent={
        <Card outlined>
          <Box paddingX='5' paddingY='2' width='100%'>
            <Flex alignX='center' alignY='center'>
              <QRCode value={registrationData.uri} />
            </Flex>
          </Box>
        </Card>
      }
      buttonLabel={FINISH}
      buttonAction={finishRegistration}
      buttonDisabled={!otp}
      isProcessing={isProcessing}
      {...otherProps}
    >
      <Box paddingTop='2' paddingBottom='5'>
        <Flex direction='column' gap='2'>
          <Box paddingY='2'>
            <Label htmlFor='totp-verification-code'>
              {SETUP_MFA_TOTP_VERIFICATION_CODE}
            </Label>
          </Box>
          <Group isDisabled={isProcessing}>
            <GroupItem>
              <Input
                id='totp-verification-code'
                variation='unstyled'
                type='number'
                value={otp}
                onChange={handleOTPChange}
                placeholder={SETUP_MFA_TOTP_VERIFICATION_CODE_PLACEHOLDER}
                autoFocus
              />
            </GroupItem>
          </Group>
        </Flex>
      </Box>
    </SetupTOTPStep>
  )
}
